export function hostFromUrl(url: string): string {
  return (url || '').trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/.*$/, '');
}

/**
 * One place formats a day for the wizard, so no component invents its own. An
 * unparseable value yields nothing rather than "Invalid Date".
 */
export function formatRunDate(value?: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
